<!-- <div *ngIf="editable">
	<button (click)="clickAddSingleAddress()">Place Non-stacked Addresses</button>
	<button (click)="clickAddMultiStoryAddress()">Place Stacked Addresses</button>
</div> -->
<div class="float-drag" cdkDrag>
	<div class="float-container" [style.height]="containerHeight">
        <div class="float-header" cdkDragHandle>
			<div class="header-text">Address Assignment Wizard</div>
			<i class="glyphicons glyphicons-remove" (click)="close()"></i>
        </div>
		
		<!-- <div class="Address-Options">
			<mat-button-toggle-group #group="matButtonToggleGroup" [value]="action" (change)="selectAction($event.value)">
				<mat-button-toggle *ngFor="let ac of actionList" [value]="ac.action" (click)="clickAction(ac.action)">
					<div>{{ac.label}}</div>
				</mat-button-toggle>
			</mat-button-toggle-group>
		</div> -->

		<div [ngSwitch]="action" class="wizard-step-container">
			<div *ngIf="step1.num <= stepNum" [@fadeInOut]>
				<app-wizard-step-title [stepNum]="step1.num" [stepLabel]="step1.label" [isCurrent]="step1.num===stepNum"></app-wizard-step-title>
				<div class="address-options step-detail">
					<!-- <mat-button-toggle-group #group="matButtonToggleGroup" [value]="action" (change)="selectAction($event.value)">
						<mat-button-toggle *ngFor="let ac of actionList" [value]="ac.action" (click)="clickAction(ac.action)">
							<div>{{ac.label}}</div>
						</mat-button-toggle>
					</mat-button-toggle-group> -->
					<div *ngFor="let ac of actionList" class="same-line">
						<input type="radio" name="action" [value]="ac.action" [(ngModel)]="action" (ngModelChange)="selectAction()">
						<div>{{ac.label}}</div>
					</div>
				</div>
			</div>
			<ng-container *ngSwitchCase="'adhoc'">
				<ng-container *ngFor="let step of adhocSteps">
					<div *ngIf="step.num <= stepNum" [@fadeInOut]>
						<app-wizard-step-title [stepNum]="step.num" [stepLabel]="step.label" [isCurrent]="step.num===stepNum"></app-wizard-step-title>
						<!-- <div *ngIf="step.num===2" class="step-detail">
							<div *ngFor="let assignment of assignmentTypes" class="same-line" style="margin-bottom: 8px;">
								<input name="assignmentType" type="radio" [value]="assignment.value" [(ngModel)]="assignmentType" (ngModelChange)="onChangeAssignmentType()">
								<div>{{assignment.label}}</div>
							</div>
						</div> -->
					</div>
				</ng-container>
			</ng-container>
			<ng-container *ngSwitchCase="'sequenced'">
				<ng-container *ngFor="let step of sequenceSteps">
					<div *ngIf="step.num <= stepNum" [@fadeInOut]>
						<app-wizard-step-title [stepNum]="step.num" [stepLabel]="step.label" [isCurrent]="step.num===stepNum"></app-wizard-step-title>
						<div *ngIf="step.num===3" class="step-detail sequence-type-step">
							<div class="">
								<div class="same-line" style="margin-bottom: 4px;">
									<div class="same-line sequence-type-first">
										<input name="sequenceType" type="radio" value="incrementBy" [(ngModel)]="sequenceType" (ngModelChange)="onChangeSequenceType()">
										<div>Increment by fixed interval</div>
									</div>
									<input name="incrementBy" type="number" [(ngModel)]="incrementBy" (ngModelChange)="onChangeIncrementBy()">
									<!-- <div class="same-line">
										<div class="sequence-type-first" style="padding-left: 10px;">Starting Address</div>
										<input name="startAddress" type="number" [(ngModel)]="startAddressNum" (ngModelChange)="onChangeStartAddress()">
									</div> -->
								</div>
								<div class="same-line">
									<div class="same-line sequence-type-first">
										<input name="sequenceType" type="radio" value="unitPerMile" [(ngModel)]="sequenceType" (ngModelChange)="onChangeSequenceType()">
										<div>By address density </div>
									</div>
									<input name="unitPerMile" type="number" [(ngModel)]="unitPerMile" (ngModelChange)="onChangeUnitPerMile()">
									<div style="margin-left: 5px;"> Units per mile, per side</div>
								</div>
							</div>
						</div>
					</div>
				</ng-container>
			</ng-container>
			<ng-container *ngSwitchCase="'stacked'">
				<ng-container *ngFor="let step of stackSteps">
					<div *ngIf="step.num <= stepNum" [@fadeInOut] [ngClass]="{'step-title-line': step.isSameLine}">
						<app-wizard-step-title [stepNum]="step.num" [stepLabel]="step.label" [isCurrent]="step.num===stepNum"></app-wizard-step-title>
						<!-- <input *ngIf="step.num===3" type="number" name="assignedAddress" [(ngModel)]="stackAssignedAddress" (ngModelChange)="onChangeStackAssignedAddress()"> -->
						<div *ngIf="step.num===2" class="step-detail stack-sub-address">
							<div class="sub-address-props">
								<div class="same-line">
									<div class="sub-address-label">Address Number </div>
									<input required type="number" name="stackAddrNum" [(ngModel)]="stackAddrNum" (ngModelChange)="onChangeStackAddrNum()">
								</div>
							</div>
							<div class="sub-address-props">
								<div class="same-line">
									<div class="sub-address-label">Building </div>
									<input type="text" name="stackBuilding" [(ngModel)]="stackBuilding" (ngModelChange)="onChangeStackBuilding()">
								</div>
							</div>
							<div class="sub-address-props">
								<div class="same-line">
									<div class="sub-address-label">Floor </div>
									<input required type="number" name="stackFloor" [(ngModel)]="stackStartFloor" (ngModelChange)="onChangeStackFloor()">
								</div>
								<div class="same-line">
									<div class="sub-address-label">Number of Floors </div>
									<input required type="number" name="numOfStackedAddress" [(ngModel)]="numOfStackedAddress" (ngModelChange)="onChangeNumOfStackedAddress()">
								</div>
							</div>
							<div class="sub-address-props sub-unit-props">
								<div class="same-line">
									<div class="sub-address-label">Unit </div>
									<input type="number" name="unit" [(ngModel)]="stackStartUnit" (ngModelChange)="onChangeStackUnit()">
								</div>
								<div class="">
									<div class="same-line">
										<div class="sub-address-label">Unit Increment </div>
										<input type="number" name="unitIncrement" [(ngModel)]="stackUnitIncrement" (ngModelChange)="onChangeStackUnitIncrement()">
									</div>
									<div class="same-line">
										<div class="sub-address-label">Unit Prefix </div>
										<input type="text" name="unitPrefix" [(ngModel)]="unitPrefix" (ngModelChange)="onChangeStackUnitPrefix()">
									</div>
									<div class="same-line">
										<div class="sub-address-label">Unit Postfix </div>
										<input type="text" name="unitPrefix" [(ngModel)]="unitPostfix" (ngModelChange)="onChangeStackUnitPostfix()">
									</div>
								</div>
							</div>
							<div class="sub-address-props">
								<div class="same-line">
									<div class="sub-address-label">Start Elevation (m) </div>
									<input type="number" name="startElevation" [(ngModel)]="stackStartElevation" (ngModelChange)="onChangeStackElevation()">
								</div>
								<div class="same-line">
									<div class="sub-address-label">Height per Floor (m) </div>
									<input type="number" name="heighPerFloor" [(ngModel)]="stackHeightPerFloor" (ngModelChange)="onChangeHeightPerFloor()">
								</div>
							</div>
						</div>
					</div>
				</ng-container>
			</ng-container>
		</div>

		<div class="float-popup-footer">
            <div class="button-groups">
                <button class="button-general" (click)="cancel()">Cancel</button>
                <button *ngIf="!checkApplyDisabled()" class="button-general" (click)="apply()">Add Cards</button>
            </div>
        </div>
		<!-- <div *ngIf="action==='multi'">
			<div>Number of Addresses:</div>
			<input type="text" name="numOfAddress" [(ngModel)]="numOfAddress" (ngModelChange)="onChangeNumOfAddress()">
		</div> -->
	</div>
</div>

<div *ngIf="showAddressNumInput" [id]="addressNumElemId" class="address-number">
	<input name="addressNumInput" [(ngModel)]="addressNumInput">
</div>